import React from 'react';
import { ThemeProvider, Box } from '@mui/material';
import formResponseMuiTheme from 'pages/Forms/Theme/formResponseMuiTheme';
import { SignatureCanvas } from 'pages/Forms/RegisterForm/CustomFormBuilder/components/SignatureCanvas/SignatureCanvas';
import { FieldsInputTitle } from 'pages/Forms/FormResults/FormResultDetails/ResultInputs/components/common/FieldsInputTitle';
import SignatureField from '../../../components/SignatureField/SignatureField';
import { SignatureFieldProps } from '../../type/preview.type';
import { useSignaturePreviewHooks } from '../../hooks/useSignaturePreviewHooks';

export const SignatureFieldPreview: React.FC<SignatureFieldProps> = ({
  element,
  handleDirty,
  tableId,
  rowIndex,
  colIndex,
  updateAnswer,
}) => {
  const theme = formResponseMuiTheme;

  const {
    sigCanvas,
    isDialogOpen,
    setIsDialogOpen,
    signatories,
    attachmentLoading,
    toggleSignaturePad,
    clear,
    save,
    removeSignature,
  } = useSignaturePreviewHooks(
    element,
    handleDirty,
    tableId,
    rowIndex,
    colIndex,
    updateAnswer,
  );

  return (
    <ThemeProvider theme={theme}>
      <Box m={1}>
        {!tableId && (
          <FieldsInputTitle
            label={element?.label || element?.name}
            isRequired={element?.isRequired}
          />
        )}

        <SignatureField
          savedSignature={
            Array.isArray(signatories)
              ? signatories[0]?.file
              : signatories?.file
          }
          removeSignature={removeSignature}
          toggleSignaturePad={toggleSignaturePad}
          isLoading={attachmentLoading}
          created_at={
            Array.isArray(signatories)
              ? signatories[0]?.created_at
              : signatories?.created_at
          }
        />

        <SignatureCanvas
          sigCanvas={sigCanvas}
          clear={clear}
          save={save}
          setIsDialogOpen={setIsDialogOpen}
          isDialogOpen={isDialogOpen}
        />
      </Box>
    </ThemeProvider>
  );
};
